export default function ModalHeader({ title }) {
  return (
    <div className="modal-header">
      <h5 className="modal-title">{title}</h5>
    </div>
  );
}
